import { cn } from "@newxsystems/shared";
import { DaylightCardLink } from "../DaylightCardLink/DaylightCardLink";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => {
  const Heading = headingAs;
  return (
    <div className={cn("grid grid-cols-1 gap-6 sm:grid-cols-2", columns[columnCount || 3])}>
      {items.map((item, index) => (
        <DaylightCardLink
          className="flex flex-col overflow-hidden rounded-[28px] border border-border bg-daylight"
          key={index}
          link={item.cardLink}
        >
          <div className="relative flex-1 p-7 pt-14 before:absolute before:left-7 before:top-8 before:h-1 before:w-10 before:bg-cobalt md:p-9 md:pt-16 md:before:left-9">
            <Heading className="font-daylight-display text-3xl font-semibold leading-tight transition-colors group-hover:text-primary">
              {item.heading}
            </Heading>
            {item.description ? (
              <DaylightRichText
                className="mt-4 text-base text-basalt md:text-lg"
                content={item.description}
              />
            ) : null}
          </div>
          <DaylightMedia
            aspectRatio={imageAspectRatio || "16:9"}
            className="rounded-none"
            media={item.image.image}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
        </DaylightCardLink>
      ))}
    </div>
  );
};

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
